import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_VISUAL_LANGUAGE } from './schema';

const QUERY = gql`
  query CustomerVisualLanguages($id: ID!) {
    customer(id: $id) {
      id
      visualLanguages {
        ...VisualLanguage
      }
    }
  }
  ${FRAGMENT_VISUAL_LANGUAGE}
`;

export const queryCustomerVisualLanguages = async (id) => {
  const variables = { id };

  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  const customer = getSingleProp(result.data);
  return customer?.visualLanguages || [];
};
